<company-publication
  *ngFor="let publication of publications$ | async; trackBy: trackById"
  [model]="publication"
  [companyName]="false"
></company-publication>

<ng-container *ngIf="loading$ | async">
  <company-publication-skeleton></company-publication-skeleton>
  <company-publication-skeleton></company-publication-skeleton>
  <company-publication-skeleton></company-publication-skeleton>
</ng-container>

<div class="news-btn-wrap">
  <button
    class="btn btn--ghost"
    type="button"
    [disabled]="(page$ | async) + 1 >= (nbPages$ | async)"
    (click)="loadMore()"
    i18n
  >
    Voir plus
  </button>
</div>
